module.exports = __webpack_public_path__ + "img/lift2.34dc64d0.jpg";